import { render, staticRenderFns } from "./MsRadio.vue?vue&type=template&id=0c3419a6&scoped=true&lang=html"
import script from "./MsRadio.vue?vue&type=script&lang=js"
export * from "./MsRadio.vue?vue&type=script&lang=js"
import style0 from "./MsRadio.vue?vue&type=style&index=0&id=0c3419a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3419a6",
  null
  
)

export default component.exports